import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import PythonService from "src/api/PythonService";
import colorPalette from "src/assets/js/colorPalette";
import Label from "src/views/dashboard/lavel_icon";
import Value from "src/views/dashboard/Value_icon";
class RadialChart extends React.Component {
  constructor(props) {
    super(props);
    this.Legend = this.Legend.bind(this);   
    this.dataLabels = this.dataLabels.bind(this); 

    this.state = {
      series:this.props.prams.filterData[this.props.prams.prams.kpiId]['series'],
      options: {
        colors:colorPalette[0]['d3Color'],
        chart: {
          fontFamily:'gadugi',
          style: {
            fontSize: '32px',    
            fontFamily:'gadugi',            
         
          },
          type:this.props.prams.filterData[this.props.prams.prams.kpiId]['options']['type']
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 5,
              size: '40%',
              background: 'transparent',
              image: undefined,
            },
            dataLabels: {
              style: {
                fontSize: '14px',   
                fontWeight: 500,
                fontFamily:'gadugi',            
                colors: ["#2C384AF2"]
              },
              name: {
                show: false,
                  fontSize: '14px',   
                  fontWeight: 500,
                  fontFamily:'gadugi',            
                  colors: ["#2C384AF2"]
                
              },
              value: {
                show: false,
                fontSize: '14px',   
                fontWeight: 500,
                fontFamily:'gadugi',            
                colors: ["#2C384AF2"]
              }
            }
          }
        },
        labels:this.props.prams.filterData[this.props.prams.prams.kpiId]['options']['labels'],
        legend: {
          show: false,
          floating: true,
          fontSize: '10px',
          position: 'left',
          offsetX: 80,
          offsetY: 0,
          labels: {
            useSeriesColors: true,
          },
          markers: {
            size: 0
          },
          formatter: function(seriesName, opts) {
            return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex]
          },
          itemMargin: {
            vertical: 3
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
                show: true
            }
          }
        }]
      },
    
    
    };
   
  }

  Legend() {
    this.setState(prevState => ({
      options: {
        ...prevState.options,
        legend: {
          ...prevState.options.legend,
          show: !prevState.options.legend.show
          
        }
      }
    }));
  }
  
  dataLabels(){   
   
    this.setState(prevState => ({
        options: {
          ...prevState.options,
          plotOptions: {
            ...prevState.options.plotOptions,
            radialBar:{
              ...prevState.options.plotOptions.radialBar,
              dataLabels:{
                ...prevState.options.plotOptions.radialBar.dataLabels,
                name:{
                  ...prevState.options.plotOptions.radialBar.dataLabels.name,
                  show:!this.state.options.plotOptions.radialBar.dataLabels.name.show
                },
                value:{
                  ...prevState.options.plotOptions.radialBar.dataLabels.value,
                  show:!this.state.options.plotOptions.radialBar.dataLabels.value.show
                }
              }
            }
           
          }
        }
      }));
    }
  

  render() {
    if(this.props.prams.filterData[this.props.prams.prams.kpiId]!=undefined){
    return (
      <div className='Polar'>
        <div className='row'>
          <div className='col-lg-10'>
            <div className='componentNameC'>{this.props.prams.prams.component}</div>
          </div>
          <div className='col-lg-2 '>
            <div class="btn-group component_action_button" role="group" aria-label="Basic example">
            <div onClick={this.dataLabels}  style={{ marginRight: '5px' }}>
                <Value show={this.state.options.plotOptions.radialBar.dataLabels.name.show}/>
            </div>
                <div onClick={this.Legend}  >
                  <Label show={this.state.options.legend.show}/>
                </div>
                
              </div>
          </div>
        </div>
        <div className="p-2 Polar1" >
        <ReactApexChart
         options={this.state.options} 
         series={this.state.series}
          type={this.props.prams.filterData[this.props.prams.prams.kpiId]['options']['chart']['type']}
          height='100%' />
          {/* <Chart
              options={this.state.options}
              series={this.state.series}
              height='100%'
              t type={this.props.prams.filterData[this.props.prams.prams.kpiId]['options']['chart']['type']}   /> */}
            
        </div>
      </div>
    );
  }else{
    return (
      <div className='Polar'>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='componentNameC'>{this.props.prams.prams.component}</div>
          </div>
        </div>
        <div className="p-4 Polar1" style={{   
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100vh', // Optionally set a height to center vertically in the viewport
        color: '#85929E'}}>
          Data Not Found!
            
        </div>
      </div>
    );
  }
}
};

export default RadialChart;
